// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.require> .el-checkbox[data-v-f41acec6]{\r\n  border: 1px solid rgb(245, 108, 108);\n}\n.item[data-v-f41acec6]{width:calc(100% - 30px) !important}\r\n", ""]);
// Exports
module.exports = exports;
